import React from 'react'
import { Container } from '@material-ui/core'
import { Grid } from '@material-ui/core'
import { ContractBulletPure, ContractBulletActionPure } from '../../pures'
import './contract.css'
import { Fragment } from 'react'

const ContractView = (props) => {
  return (
    <Fragment>

      <Container spacing={6} lg={12} md={12} sm={12} className='contract-size' >
        <Grid container className='container contract' spacing={2}>
          <Grid style={{ padding: '0px' }} item xs={12} lg={12} md={12} sm={12} es={12}>
            <div style={{ maxHeight: '531px' }}>
              <ContractBulletPure
                data={props.contractBullets}
                onAcceptTermnsAndConditions={props.onAcceptTermnsAndConditions}
                onAcceptPlan={props.onAcceptPlan}
                termnsAndConditions={props.termnsAndConditions}
                planChecked={props.planChecked}
              />
            </div>
          </Grid>
        </Grid>
        <ContractBulletActionPure
          withoutPasswordSign={props.withoutPasswordSign}
          onAcceptTermnsAndConditions={props.onAcceptTermnsAndConditions}
          onAcceptPlan={props.onAcceptPlan}
          termnsAndConditions={props.termnsAndConditions}
          planChecked={props.planChecked}
          userTypeId={props.userTypeId}
        />
      </Container>
    </Fragment>
  )
}

export { ContractView as default }
